var map = {
	"./decidim/avatar-multiuser.png": 687,
	"./decidim/brands/facebook.svg": 67247,
	"./decidim/brands/google.svg": 89718,
	"./decidim/brands/twitter-x.svg": 93919,
	"./decidim/cc-badge.png": 11781,
	"./decidim/decidim-logo.svg": 30781,
	"./decidim/default-avatar.svg": 40749,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 92403,
	"./decidim/icons.svg": 54492,
	"./decidim/pattern.png": 53567,
	"./decidim/placeholder-card-g.svg": 79300,
	"./decidim/placeholder-card-l.svg": 36127,
	"./decidim/placeholder.jpg": 96518,
	"./decidim/remixicon.symbol.svg": 46124,
	"./decidim/vendor/social-share-button/douban.svg": 23519,
	"./decidim/vendor/social-share-button/email.svg": 13640,
	"./decidim/vendor/social-share-button/facebook.svg": 7572,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 59872,
	"./decidim/vendor/social-share-button/hacker_news.svg": 58476,
	"./decidim/vendor/social-share-button/linkedin.svg": 51342,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 93511,
	"./decidim/vendor/social-share-button/pinterest.svg": 70982,
	"./decidim/vendor/social-share-button/reddit.svg": 44380,
	"./decidim/vendor/social-share-button/telegram.svg": 38705,
	"./decidim/vendor/social-share-button/tumblr.svg": 57134,
	"./decidim/vendor/social-share-button/twitter.svg": 5477,
	"./decidim/vendor/social-share-button/vkontakte.svg": 54103,
	"./decidim/vendor/social-share-button/wechat.svg": 90018,
	"./decidim/vendor/social-share-button/whatsapp.svg": 12642,
	"./decidim/vendor/social-share-button/x.svg": 64168,
	"./decidim/vendor/social-share-button/xing.svg": 21152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88380;